var map = {
	"./Pattern01.png": "9649",
	"./Pattern02.png": "ff19",
	"./Pattern03.png": "50c3",
	"./Pattern04.png": "08b9",
	"./Pattern05.png": "5d30",
	"./Pattern06.png": "cbb1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e249";